import React, { Component } from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';

import { message } from 'antd';
import { querySaveDepartmentOpportunity } from '@api/crm/crm';
import FormCustom from './FormStage';

class BaseForm extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  handleAdd = params => {
    querySaveDepartmentOpportunity(params).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        browserHistory.go(-1);
      }
    });
  };

  render() {
    return (
      <div>
        <FormCustom handleSubmit={this.handleAdd} {...this.props} />
      </div>
    );
  }
}

export default connect(state => ({ organization: state.organization }))(BaseForm);



// WEBPACK FOOTER //
// ./src/components/crm/department/stage/PageAdd.js